export const getAuthToken = () => {
  return localStorage.getItem("offset-go-admin-token") || "";
};

export const setAuthToken = (token) => {
  localStorage.setItem("offset-go-admin-token", token);
};

export const removeAuthToken = () => {
  localStorage.removeItem("offset-go-admin-token");
};

export const setAuthUser = ({ email, kyc_verified, name, user_type }) => {
  localStorage.setItem(
    "offset-go-admin-user",
    JSON.stringify({ email, kyc_verified, name, user_type })
  );
};

export const removeAuthUser = () => {
  localStorage.removeItem("offset-go-admin-user");
};
